<ng-container *ngIf="reportItem === null; else reportDetaills">
  <div class="no-appoint-message">
    <div>No Data Found!</div>
  </div>
</ng-container>

<ng-template #reportDetaills>
  <div class="report-container" *ngIf="reportItem !== null">
    <div class="report-header">
      <div class="logo-container">
        <div class="report-logo">
          <img src="assets/images/arogyamm.png" alt="" srcset="" />
        </div>
        <div class="doctor-name">
          Dr. {{ reportItem?.doctorName }}
          <div>{{ reportItem?.degree }}</div>
        </div>
      </div>
      <div class="doctor-container">
        <br />
        <div>{{ reportItem?.clinicName }}</div>
        <div>{{ reportItem?.address }}</div>
        <div *ngIf="reportItem?.registration" class="registration-number">
          Medical Registration Number: {{ reportItem?.registration }}
        </div>
      </div>
    </div>
    <div class="patient-container">
      <div>
        {{ reportItem!.patientName }}
        <div>
          <ng-container *ngIf="reportItem?.patientGender">
            {{ reportItem?.patientGender }}</ng-container
          >
        </div>
        <div>
          <ng-container *ngIf="reportItem?.patientAge">
            {{ reportItem?.patientAge }} Years</ng-container
          >
        </div>
        <div>
          <ng-container *ngIf="reportItem?.patientWeight">
            {{ reportItem?.patientWeight }} KG</ng-container
          >
        </div>
      </div>
      <div>{{ reportItem!.date | date: "dd MMM yyyy" }}</div>
    </div>
    <div class="medicine-container" *ngIf="reportItem?.followUpDate">
      <div
        class="followup-container"
        *ngIf="reportItem?.followUpDate"
      >
        <div class="medicine-header">
          FOLLOW UP DATE -
          {{ reportItem.followUpDate | date: "dd MMM yyyy" }}
        </div>
      </div>
    </div>
    <div class="medicine-container">
      <div class="medicine-header">REPORT</div>
      <div class="report-title">
        {{ reportItem?.title }}
      </div>
      <div class="report-summary">
        <div [innerHTML]="reportItem?.summary | safeHtml"></div>
        <div>
          <b>IMPRESSION:</b>
          <b>{{ reportItem?.impression }}</b>
        </div>
        <br />
        <div>
          <b>ADV:</b>
          <b>{{ reportItem?.adv }}</b>
        </div>
      </div>
      <div class="report-images-container">
        <ng-container *ngFor="let report of reportItem?.report[0]?.images">
          <div class="image-container">
            <img
              class="report-pic"
              *ngIf="report"
              [src]="
                environment.baseURL + 'appointment/scan/cdn/' + report || ''
                  | safeImage
              "
            />
          </div>
        </ng-container>
      </div>
    </div>
    <div class="notes-container">
      <div>Note: {{ reportItem?.report[0]?.notes }}</div>
    </div>
    <div class="sign-container">
      <div>Dr. {{ reportItem?.doctorName }}</div>
      <div>{{ reportItem?.degree }}</div>
    </div>
    <div class="disclaimer-container">
      Disclaimer: This report is based on the information provided by you. Visit
      doctor in case of emergency. This report is valid in India only.
    </div>
  </div>
</ng-template>
